import { useQuery } from '@tanstack/react-query'
import { listProducts } from '@/lib/api/amazon-listing'

export function useAmazonProducts(params: {
  limit?: number
  offset?: number
  search?: string
}) {
  return useQuery({
    queryKey: ['amazon-products', params],
    queryFn: () => listProducts(params),
    staleTime: 30_000,
  })
}
